// Electric Resistance units with conversion factors to ohm (Ω)
export const electricResistanceUnits = [
  { id: 'ohm', name: 'Ohm', symbol: 'Ω', plural: 'Ohms', factor: 1 },
  { id: 'megaohm', name: 'Megaohm', symbol: 'MΩ', plural: 'Megaohms', factor: 1e6 },
  { id: 'kiloohm', name: 'Kiloohm', symbol: 'kΩ', plural: 'Kiloohms', factor: 1e3 },
  { id: 'milliohm', name: 'Milliohm', symbol: 'mΩ', plural: 'Milliohms', factor: 1e-3 },
  { id: 'microohm', name: 'Microohm', symbol: 'µΩ', plural: 'Microohms', factor: 1e-6 },
  { id: 'nanoohm', name: 'Nanoohm', symbol: 'nΩ', plural: 'Nanoohms', factor: 1e-9 },
  { id: 'abohm', name: 'Abohm', symbol: 'abΩ', plural: 'Abohms', factor: 1e-9 },
  { id: 'statohm', name: 'Statohm', symbol: 'statΩ', plural: 'Statohms', factor: 8.987552e11 },
  { id: 'volt-per-ampere', name: 'Volt/Ampere', symbol: 'V/A', plural: 'Volts/Ampere', factor: 1 },
  { id: 'reciprocal-siemens', name: 'Reciprocal Siemens', symbol: '1/S', plural: 'Reciprocal Siemens', factor: 1 },
];

export const popularElectricResistanceConversions = [
  { from: 'ohm', to: 'kiloohm' },
  { from: 'kiloohm', to: 'ohm' },
  { from: 'ohm', to: 'megaohm' },
  { from: 'megaohm', to: 'ohm' },
  { from: 'ohm', to: 'milliohm' },
  { from: 'milliohm', to: 'ohm' },
];

export const getUnitById = (id) => electricResistanceUnits.find(unit => unit.id === id);

export const convertElectricResistance = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert electric resistance units and learn the conversion formula.`;
};
